import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER } from "src/constant/common";

const GNSSSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.gnss_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY}`)}
          name={`MCS.${FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.HORIZONTAL_POSITION_ACCURACY}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.VELOCITY_ACCURACY}`)}
          name={`MCS.${FORM_NAME.MCS.VELOCITY_ACCURACY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_ACCURACY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.VELOCITY_ACCURACY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_ACCURACY}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_ACCURACY}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_ACCURACY}`) })}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY}`)}
          name={`MCS.${FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.VERTICAL_POSITION_ACCURACY}`) })}
        />
      </div>
    </div>
  );
};

export default GNSSSigma;
